import React from "react"
import ReactCompareImage from "react-compare-image"

export const Compare = ({ imageOne, imageTwo }) => (
  <ReactCompareImage leftImage={imageOne} rightImage={imageTwo} />
)

export default Compare
